import React from 'react';

import { ChevronLeftIcon, CloseIcon } from '@infinex/ui-icons';
import { Button, Text } from '@infinex/ui/components';

import { FullscreenContainer } from './FullscreenContainer';

export interface FullscreenModalProps {
  /** Large centred heading shown in the header bar. */
  title?: string;
  /** Route to navigate to when the close button is pressed. */
  onClose?: () => void;
  /** Route to navigate to when the back button is pressed. */
  onBack?: () => void;
  className?: string;
  children: React.ReactNode;
  isTabView?: boolean; // Pass this prop to indicate if running in tab view
}

export function FullscreenModal({
  onClose,
  onBack,
  title,
  className = 'bg-canvas',
  children,
  isTabView = false,
}: FullscreenModalProps) {
  return (
    <FullscreenContainer className={className} isTabView={isTabView}>
      <div className="relative flex h-full w-full flex-col p-6">
        {/* ───── Header ───── */}
        <header className="relative flex items-center justify-center">
          {onBack && (
            <Button
              aria-label="Back"
              size="small"
              prominence="low"
              onPress={onBack}
              className="bg-fill hover:bg-fillHover absolute top-0 left-0 rounded-full"
            >
              <ChevronLeftIcon className="size-5" />
            </Button>
          )}

          {title && (
            <Text className="text-emphasis mt-1 text-base font-semibold">
              {title}
            </Text>
          )}

          {onClose && (
            <Button
              aria-label="Close"
              size="small"
              prominence="low"
              onPress={onClose}
              className="bg-fill hover:bg-fillHover absolute top-0 right-0 rounded-full"
            >
              <CloseIcon className="size-5" />
            </Button>
          )}
        </header>

        {/* ───── Scrollable body ───── */}
        <div className="flex-1 overflow-y-auto pt-8">{children}</div>
      </div>
    </FullscreenContainer>
  );
}
